import { CustomMeetYourHerbsState } from "@gaiaProfessionals/Store/MeetYourHerbs/GAIAMeetYourHerbsReducer";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { WidgetGroup } from "@insite/client-framework/Types/WidgetGroups";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomMeetYourHerbsState) => {
    const product = state.customMeetYourHerbsReducer?.product;
    return {
        product,
    };
};
interface OwnProps {
    product: any;
}

type Props = OwnProps & WidgetProps & ReturnType<typeof mapStateToProps>;

export interface GAIAMYHPurityTestingStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
    titleText?: TypographyProps;
}

export const partNumberStyles: GAIAMYHPurityTestingStyles = {
    labelText: {
        size: 15,
        fontFamily: "Lato",
        css: css`
            margin-right: 5%;
            min-width: 220px;
            text-transform: capitalize;
            width: 48%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            min-width: 190px;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    valueText: {
        size: 15,
        fontFamily: "Lato",
        css: css`
            display: flex;
            padding: 8px 0px;
            border-bottom: 1px solid #ccc;
            &:last-child: {
                border-bottom: none !important;
            }
        `,
    },
    titleText: {
        size: 15,
        fontFamily: "LatoBold",
        css: css`
            display: flex;
            padding-bottom: 11.5px;
            border-bottom: 1px solid #ccc;
            width: 100%;
        `,
    },
};

const styles = partNumberStyles;

const GAIAMYHPurityTesting: React.FC<Props> = ({ product }) => {
    if (!product?.cofc?.purity_tests) {
        return null;
    }
    const batchDetails = Object.keys(product?.cofc?.purity_tests);

    return (
        <StyledWrapper>
            <Typography {...styles.titleText}>{translate("Latest Batch Details")}</Typography>
            {batchDetails.map(label => (
                <Typography {...styles.valueText} as="p" key={label}>
                    <Typography {...styles.labelText} as="p">
                        {label}
                    </Typography>
                    <Typography>
                        {product?.cofc?.purity_tests[label]?.every((o: { result: string }) => o.result === "Pass")
                            ? "Passed"
                            : "Failed"}
                    </Typography>
                </Typography>
            ))}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(GAIAMYHPurityTesting),
    definition: {
        displayName: "MYH Purity Testing",
        group: "MYH Product Details" as WidgetGroup,
    },
};

export default widgetModule;
